var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 18,
    viewBox: "0 0 72 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_4533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3058 9.07073C18.3058 12.5073 12.8273 18.0003 9.39953 18.0003C5.97177 18.0003 0.493164 12.5073 0.493164 9.07073C0.493164 5.63412 5.97177 0.141052 9.39953 0.141052C12.8273 0.141052 18.3058 5.63412 18.3058 9.07073ZM12.962 9.07073C12.962 10.4454 10.7705 12.6425 9.39953 12.6425C8.02837 12.6425 5.83696 10.4454 5.83696 9.07073C5.83696 7.69611 8.02846 5.49885 9.39953 5.49885C10.7705 5.49885 12.962 7.69611 12.962 9.07073Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0053 17.9992C31.3291 17.9992 33.412 15.9107 34.044 13.165H30.3927C29.9481 14.1037 29.2459 14.8077 28.0053 14.8077C26.5073 14.8077 25.4073 13.7283 25.4073 11.8743C25.4073 10.0205 26.5073 8.94093 28.0053 8.94093C29.2459 8.94093 29.9481 9.64496 30.3927 10.5837H34.044C33.412 7.83807 31.3291 5.74949 28.0053 5.74949C24.4476 5.74949 21.8496 8.47172 21.8496 11.8743C21.8496 15.2771 24.4476 17.9992 28.0053 17.9992ZM35.2904 17.7411H38.8248V0.140962H35.2904V17.7411ZM42.6925 4.41186C43.9331 4.41186 44.9161 3.42627 44.9161 2.20597C44.9161 0.98577 43.9331 0.000183105 42.6925 0.000183105C41.4989 0.000183105 40.4924 0.98577 40.4924 2.20597C40.4924 3.42627 41.4989 4.41186 42.6925 4.41186ZM40.9371 17.7411H44.4715V6.0077H40.9371V17.7411ZM52.0376 17.9992C55.361 17.9992 57.444 15.9107 58.0762 13.165H54.4249C53.9799 14.1037 53.278 14.8077 52.0376 14.8077C50.5393 14.8077 49.4395 13.7283 49.4395 11.8743C49.4395 10.0205 50.5393 8.94093 52.0376 8.94093C53.278 8.94093 53.9799 9.64496 54.4249 10.5837H58.0762C57.444 7.83807 55.361 5.74949 52.0376 5.74949C48.4799 5.74949 45.8818 8.47172 45.8818 11.8743C45.8818 15.2771 48.4799 17.9992 52.0376 17.9992ZM67.2103 17.7411H71.4934L66.1571 11.3112L70.4637 6.0077H66.2738L62.8567 10.2082V0.140962H59.3226V17.7411H62.8567V12.5079L67.2103 17.7411Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_4533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.61364a9ae0a237f2ffab432c68fe8c7d.svg";
export { ForwardRef as ReactComponent };